var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-card-text", [
    _c("div", [
      _vm.action.Init
        ? _c("div", {
            staticClass: "body-text stark--text mt-2",
            domProps: { innerHTML: _vm._s(_vm.action.Init) }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.action.Trigger
        ? _c("div", [
            _c("div", { staticClass: "subtle--text overline mb-n2" }, [
              _vm._v("Trigger")
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "body-text stark--text",
              domProps: { innerHTML: _vm._s(_vm.action.Trigger) }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.action.Detail
        ? _c("div", [
            _c("div", { staticClass: "subtle--text overline mb-n2" }, [
              _vm._v("Effect")
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "body-text stark--text",
              domProps: { innerHTML: _vm._s(_vm.action.Detail) }
            })
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }